import $ from './jquery.js';
import './bootstrap';
import * as bootstrap from 'bootstrap';
import 'owl.carousel';
import Lightbox from 'bs5-lightbox';
import SimpleParallax from 'simple-parallax-js/vanilla';
import toastr from 'toastr';

window.$ = $;
window.bootstrap = bootstrap;
window.toastr = toastr;

import.meta.glob([
    '../img/**',
]);

$(document).ready(function () {
    /* Favicon */
    var link = document.querySelector("link[rel~='shortcut']");
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "shortcut icon");
        document.head.appendChild(link);
    }

    $.get("/img/icon.svg", [], function(response) {
        let $color = $("meta[name=theme-color]");
        let color;
        if($color.length <= 0) {
            color = "#009a3d";
        } else {
            color = $color.attr("content");
        }

        let $svg = $(response.children[0]);
        $svg.find("#color path").css({fill: color});

        link.href = 'data:image/svg+xml;base64,' + btoa(new XMLSerializer().serializeToString($svg[0]));
    });
    /* EndFavicon */

    moveMenu();
    setTimeout(function() {
        moveMenu();
    }, 500)
    $(window).scroll(function () {
        initializeMenu();
        menuColor();
        animateIn();
        const navbarCollapsible = document.getElementById('navbar');
        let navbarCollapse = new bootstrap.Collapse(navbarCollapsible, {toggle: false});
        navbarCollapse.hide();
    })
    $(window).resize(function () {
        moveMenu();
    })

    document.querySelectorAll('[data-toggle=lightbox]').forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        new Lightbox(el);
    }));

    $('.owl-carousel.gallery').owlCarousel({
        dots: false,
        autoplay: true,
        loop: true,
        autoplayTimeout: 2500,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    });

    $("[data-filter]").click(function() {
        let $filter = $(this).data("filter");
        let $filter_on = $(this).data("filter-on");
        let $remove_class = $(this).data("filter-remove-class");
        let $add_class = $(this).data("filter-add-class");
        $($filter_on).removeClass($remove_class);
        $($filter).addClass($add_class);
        $(".program-more-text").removeClass('appear');
        animateIn();
    });

    $('#foto .prev').click(function() {
        $('.owl-carousel').trigger('prev.owl.carousel');
    });

    $('#foto .next').click(function() {
        $('.owl-carousel').trigger('next.owl.carousel');
    });

    $('[data-show]').click(function() {
        var el = $(this).data('show');
        $(el).toggleClass('appear');
        animateIn();
    });

    $('.ajax-form').submit(function(e) {
        e.preventDefault();
        let $form = $(this);
        $form.find("input[name=test]").val(0);
        $form.find(".is-invalid, .is-valid").removeClass('is-valid is-invalid');
        $form.find('.message-success').removeClass('show');
        $form.find(".invalid-feedback, .alert").remove();
        $form.prepend(`<div class="alert alert-warning d-flex justify-content-center align-items-center"><div class="spinner-border me-2" role="status"></div></i> Odesílání...</div>`);
        if (window.outerWidth < 576) {
            $form[0].scrollIntoView();
        }
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            dataType: 'json',
            success: function(data) {
                if (data.state === true) {
                    if (data.reset === true) {
                        $form[0].reset();
                    }
                    if (typeof ga !== 'undefined') {
                        ga('send', 'event', 'Prihlaska', 'Lead');
                    }
                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push({'event': 'application_sent'});
                    }
                    if (data.update) {
                        data.update.forEach((updateData) => {
                            let element = $(updateData.selector);
                            if (element.length > 0) {
                                element.replaceWith(updateData.content);
                            }
                        });
                    }
                    if (data.modal) {
                        const modalElement = $(data.modal.selector);
                        if (modalElement.length > 0) {
                            const modal = new bootstrap.Modal(modalElement);
                            modal[data.modal.action]();
                        }
                    }
                } else {
                    Object.entries(data.messages).forEach(([key, value]) => {
                        let $input = $form.find(`[name=${key}]`);
                        $input.addClass("is-invalid");
                        if ($input.parent().hasClass("input-group")) {
                            $input = $input.parent();
                            $input.addClass("is-invalid");
                        }
                        $input.after(`<label for="${key}" class="invalid-feedback">${value}</label>`);
                    });
                }
                $form.find(".alert").remove();
                if (data.message) {
                    $form.prepend(`<div class="alert alert-${data.state === true ? "success" : "danger"}">${data.message}</div>`);
                } else if (!data.messages && data.state !== true) {
                    $form.prepend(`<div class="alert alert-danger">Odeslání se nepodařilo. Zkus to prosím později.</div>`);
                }
            },
            error: function (data) {
                $form.find(".alert").remove();
                $form.prepend(`<div class="alert alert-danger">Odeslání se nepodařilo. Zkus to prosím později.</div>`);
            }
        })
    });

    if (getCookie('cookies_consent')) {
        cookieConsent(getCookie('cookies_consent'));
        $("#cookie-bar").removeClass('show');
    }

    $("#cookie-bar [data-consent]").click(function() {
        cookieConsent($(this).attr("data-consent"));
    })

    if (window.location.hash) {
        let $element = $(window.location.hash)
        if ($element.length > 0) {
            $element[0].scrollIntoView();
        }
    }

    $("#program .program[data-video]").each(function () {
        $(this).hover(function () {
            let videoSrc = $(this).attr('data-video');
            $(this).find('.img').append("<video src='" + videoSrc + "' muted loop></video>");
            let $video = $(this).find('.img video');
            $video.each(function () {this.play();});
            setTimeout(function () {
                $video.addClass('show');
            }, 50);
        }, function () {
            let $video = $(this).find('.img video');
            $video.removeClass('show');
            setTimeout(function () {
                $video.remove();
            }, 300);
        });
    });

    $("[data-show-only-selector]").each(function(index, element) {
        let $element = $(element);
        let $conditionalElement = $($element.attr("data-show-only-selector"));
        $conditionalElement.change(function() {
            conditionalInputs($element, $(this))
        });
        conditionalInputs($element, $conditionalElement)
    });

    new SimpleParallax(document.getElementsByClassName('parallax'));
    // $('.parallax').parallax({imageSrc: '/img/bg.jpg'});

    animateIn();

    const navbarCollapsible = document.getElementById('navbar');
    navbarCollapsible.addEventListener('hide.bs.collapse', event => {
        document.querySelector('.navbar-toggler-icon').classList.remove('open');
    })
    navbarCollapsible.addEventListener('show.bs.collapse', event => {
        document.querySelector('.navbar-toggler-icon').classList.add('open');
    })

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});

function conditionalInputs($target, $conditionalElement) {
    if ($target.attr("data-show-only-values")?.split(',')?.includes($conditionalElement.val())) {
        $target.show();
    } else {
        $target.hide();
    }
}

function initializeMenu() {
    var $actual = $('section.actual');
    if ($actual.length === 0) $actual = $("section:nth-of-type(1)");
    var $offset = $actual[0].offsetTop;
    var $height = $offset + $actual.height();
    var $scroll = $(window).scrollTop();

    if ($scroll === 0) menu("home");

    if ($("header").css("position") === "fixed") $scroll += $("header").outerHeight();

    if ($scroll + $(window).height() >= $(window)[0].scrollHeight) menu("kontakt");

    if ($scroll >= $height || $scroll <= $offset) {
        moveMenu();
    }
}

function moveMenu() {
    for (let i = 1; i <= 11; i++) {
        let $section = $('section:nth-of-type(' + i + ')');
        if ($section.length !== 0) {
            let $offset = $section[0].offsetTop;
            let $height = $offset + $section[0].clientHeight;
            let $scroll = $(window).scrollTop() + 1;
            let $header = $("header");
            if ($header.css("position") === "fixed") $scroll += $header.outerHeight();
            if ($scroll <= $height && $scroll >= $offset) {
                menu($section.attr("id"));
                break;
            }
        }
    }
}

function menu(id) {
    let $active = $('.menu .active');
    if ($active.length > 0) {
        var $activePos = $active.offset().left;
        var $next = $(".menu li[data-sections*="+id+"]");
        $(".menu .actual").removeClass("actual");
        if ($next.length !== 0) {
            $next.addClass("actual");
            var $width = $next.width();
            var $nextPos = $next.offset().left;

            $active.offset({ left: $activePos })
            $active.clearQueue().css({ 'opacity': 1, 'width': $width, 'left': $nextPos });
        } else {
            $active.css({ 'opacity': 0 });
        }
    }
}

function menuColor() {
    if ($(window).scrollTop() > 0) {
        $("header").addClass("scrolled");
    } else {
        $("header").removeClass("scrolled");
    }
}

function animateIn() {
    let $screenHeight = $(window).height();
    $(".animate-in:not(.animate-in-on)").each(function(index, element) {
        let $element = $(element);
        let $offsetTop = getCoords(element).top;
        if ($offsetTop - $(window).scrollTop() - $screenHeight + 200 < 0 && $element.is(":visible")) {
            $element.addClass("animate-in-on");
        }
    })
}

function getCoords(elem) { // crossbrowser version
    let box = elem.getBoundingClientRect();

    let body = document.body;
    let docEl = document.documentElement;

    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    let top  = box.top +  scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function cookieConsent(value) {
    if (value === true || value === "true") {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    }
    let expiration = new Date();
    expiration.setDate(expiration.getTime() + (365*24*60*60*1000));
    document.cookie = "cookies_consent="+value+"; expires="+expiration.toUTCString();
    gtag('event', 'consent_sent');
}
